module.exports = __webpack_public_path__ + "img/05.d355709a.jpg";